module.exports = __webpack_public_path__ + "img/knue_gallery0.ab0853cb.jpg";